export default __webpack_public_path__ + "static/media/qwiklabs1.90af665c.png";